import { render, staticRenderFns } from "./SamChipSelect.vue?vue&type=template&id=1a20e2bc&scoped=true&shadow"
import script from "./SamChipSelect.vue?vue&type=script&lang=js&shadow"
export * from "./SamChipSelect.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamChipSelect.vue?vue&type=style&index=0&id=1a20e2bc&prod&scoped=true&lang=scss&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "1a20e2bc",
  null
  ,true
)

export default component.exports